import { makeStyles } from '@material-ui/styles'
import { Theme } from 'styling/theme'

export default makeStyles((theme: Theme) => ({
    buttonGroup: {
        paddingTop: 20,
        paddingLeft: 16,
        paddingRight: 16,
        display: 'flex',
        justifyContent: 'space-between',
    },
    button: {
        background: 0,
        flex: 1,
        height: 36,
        border: `solid 1px ${theme.colors.light.darkgrey}`,
        fontFamily: 'NotoSans',
        fontSize: 12,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.67,
        letterSpacing: 'normal',
        textAlign: 'center',
        color: theme.colors.white,
        display: 'block',
        padding: '.5rem 1rem',
        textDecoration: 'none',

        '&:first-child': {
            borderTopLeftRadius: 2,
            borderBottomLeftRadius: 2,
        },

        '&:last-child': {
            borderTopRightRadius: 2,
            borderBottomRightRadius: 2,
        },

        '&:hover': {
            color: theme.colors.white,
            textDecoration: 'none',
        },
    },
    active: {
        backgroundColor: theme.colors.light.darkgrey,
    },
}))
